module.exports = __webpack_public_path__ + "img/accounts-logo.fc568c27.svg";